'use strict';

import React, { Component, Fragment } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ModelPicker from 'Components/Forms/Elements/ModelPicker';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import TextInput from 'Components/Forms/Elements/TextInput';
import Switch from 'Components/Forms/Elements/Switch';
import Radios from 'Components/Forms/Elements/Radios';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import getFormData from 'Components/Forms/Functions/getFormData';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
import { discount_code_types as type_options } from 'Shared/options';
import { isTrue } from 'Shared/utilities';
const {
  app,
  qwest
} = window;
const dates_bemit = ['auto'];
const picker_params = {
  fields: ['address']
};
export default class DiscountCodeForm extends Component {
  state = {
    status_messages: {},
    'discountcode[establishments]': [],
    'discountcode[postal_code]': '',
    hidden_results: []
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchData();
    }
  }
  handleChange = ({
    ...params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (params.name === 'discountcode[type]') {
      component.setState({
        'discountcode[establishments]': [],
        'discountcode[postal_code]': ''
      });
    } else if (params.name === 'picked_establishment' && params.model?.id) {
      const field = 'discountcode[establishments]';
      const exists = (state[field] || []).find(esta => esta.id === params.vlue);
      if (!exists) {
        const new_picked = (state[field] || []).concat([params.model]);
        return component.setState({
          [field]: new_picked,
          hidden_results: new_picked.map(esta => esta.id)
        });
      }
    }
    handleChange.bind(this)({
      ...params
    });
  };
  fetchData = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    let id = props.id;
    if (!id) {
      let pathname = document.location.pathname;
      if (pathname.endsWith('/')) pathname = pathname.slice(0, -1);
      id = pathname.slice(pathname.lastIndexOf('/') + 1);
    }
    qwest.post(action('getAllDiscountCodes'), {
      id: id,
      with_count: false,
      autocomplete_establishments: true
    }).then(function (xhr, response) {
      const {
        establishments = [],
        ...discountcode
      } = response.data[0];
      const update = getStateFromObject({
        data: discountcode,
        model: 'discountcode'
      });
      ['max_use', 'offered_hours', 'min_hours'].map(field => 'discountcode[' + field + ']').forEach(field => update[field] = String(update[field] || '0'));
      component.setState({
        ...update,
        'discountcode[establishments]': establishments,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const discountcode = getFormData({
      state: state,
      pattern: 'discountcode['
    });
    const url = props.type === 'update' ? '/discount-code/update' : '/discount-code/create';
    qwest.post(url, discountcode).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchData();
      } else {
        component.setState({
          'discountcode[establishments]': [],
          'discountcode[postal_code]': '',
          hidden_results: []
        });
        let pathname = document.location.pathname;
        if (pathname.endsWith('/')) pathname = pathname.slice(0, -1);
        const redirect_to = pathname.slice(0, pathname.lastIndexOf('/'));
        window.setTimeout(function () {
          app.navigateTo(redirect_to);
        }, 1500);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  removeEtablishment = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const id = e?.target?.getAttribute?.('data-id');
    const field = 'discountcode[establishments]';
    const new_picked = (state[field] || []).filter(esta => esta.id !== id);
    return component.setState({
      [field]: new_picked,
      hidden_results: new_picked.map(esta => esta.id)
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const type = props.type === 'creation' ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement("h3", {
      className: "u-margin-top-30"
    }, "Choisissez o\xF9 appliquer ce code"), getFormStatus({
      error: state.status_messages['discountcode[type]']?.error
    }), /*#__PURE__*/React.createElement(Radios, {
      options: type_options,
      name: "discountcode[type]",
      onChange: component.handleChange,
      value: state['discountcode[type]'] || ''
    })) : undefined;
    const establishments = (state['discountcode[establishments]'] || []).map(function ({
      id,
      name,
      address
    }) {
      const zip_code = address?.postal_code ? /*#__PURE__*/React.createElement("span", {
        className: "c-picked-establishment__zipcode"
      }, '(' + address.postal_code + ')') : undefined;
      return /*#__PURE__*/React.createElement("div", {
        key: id,
        className: "c-picked-establishment"
      }, /*#__PURE__*/React.createElement("span", {
        className: "c-picked-establishment__name"
      }, name), zip_code, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        "data-id": id,
        className: "c-picked-establishment__remove",
        onClick: component.removeEtablishment
      }, /*#__PURE__*/React.createElement(DeleteIcon, {
        className: "c-picked-establishment__removve-icon"
      })));
    });
    const select_myWO = ['myWO', 'excluded_myWO'].includes(state['discountcode[type]']);
    const myWO_selection = select_myWO ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(ModelPicker, {
      model: "Etablishment",
      onPick: component.handleChange,
      picked: state['picked_establishment'],
      name: "picked_establishment",
      status_messages: state.status_messages,
      label: state['discountcode[type]'] === 'myWO' ? 'Chercher un myWO à ajouter' : 'Chercher un myWO à exclure',
      query_params: picker_params,
      "hide-results": state.hidden_results,
      clear_on_selection: true,
      "keep-open-on-select": true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "discount-form-picked-establishments"
    }, establishments))) : undefined;
    const postal_code = state['discountcode[type]'] === 'postal_code' ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['discountcode[postal_code]'],
      name: "discountcode[postal_code]",
      label: "Code postal",
      status: state.status_messages
    })) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, props.type !== 'update' ? /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['v2', 'orange', 'icon'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Espaces Lounge uniquement")) : undefined, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/discount-code/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['discountcode[title]'],
      name: "discountcode[title]",
      label: "Libell\xE9",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['discountcode[code]'],
      name: "discountcode[code]",
      label: "Code",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 8
    }, /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      className: "u-flex u-flex-wrap u-items-end\r u-flex-gap-15"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['discountcode[start]'],
      name: "discountcode[start]",
      label: "Date de l'op\xE9ration",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: dates_bemit
    }), /*#__PURE__*/React.createElement("span", {
      className: "u-self-end u-margin-bottom-10\r u-margin-right-20"
    }, "au"), /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['discountcode[end]'],
      name: "discountcode[end]",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: dates_bemit
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      className: "u-flex u-flex-wrap u-items-end\r u-flex-gap-15"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['discountcode[booking_start]'],
      name: "discountcode[booking_start]",
      label: "Date de consommation",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: dates_bemit
    }), /*#__PURE__*/React.createElement("span", {
      className: "u-self-end u-margin-bottom-10\r u-margin-left-5 u-margin-right-25"
    }, "au"), /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['discountcode[booking_end]'],
      name: "discountcode[booking_end]",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: dates_bemit
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['discountcode[max_use]'],
      name: "discountcode[max_use]",
      label: "Utilisation(s) max par client",
      status: state.status_messages,
      "safe-value": true,
      int: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['discountcode[min_hours]'],
      name: "discountcode[min_hours]",
      label: "Heure(s) minimum dans la r\xE9servation",
      status: state.status_messages,
      "safe-value": true,
      int: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['discountcode[percent_discount]'],
      name: "discountcode[percent_discount]",
      "top-label": "Type de r\xE9duction",
      "left-label": "Heure(s) offerte(s)",
      label: "% du panier",
      status: state.status_messages,
      "default-value": true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      className: "u-flex u-items-end"
    }, isTrue(state['discountcode[percent_discount]']) ? /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['discountcode[percent]'],
      name: "discountcode[percent]",
      label: "% de r\xE9duction",
      status: state.status_messages,
      "safe-value": true
    }) : /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['discountcode[offered_hours]'],
      name: "discountcode[offered_hours]",
      label: "Nombre d'heure(s) offerte(s)",
      status: state.status_messages,
      "safe-value": true,
      int: true
    })), type, myWO_selection, postal_code), status), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer ce code promo', loader)));
    return output;
  }
}
